export default __webpack_public_path__ + "static/media/TimePink.08de8d3c.svg";